import { ProductTargetingAutofillValue } from "@src/components/targeting/components/experienceProductTargeting/expressions/ProductTargetingAutofillValue";
import { EntityOption } from "@src/features/experienceBuilder/modifications/components/onsiteUpsell/entityOptions";

// Single-value adapter over the shared targeting autocomplete. The flat upsell
// condition/source fields hold one id, so we bridge string <-> {label, value}
// and reuse the already-built picker rather than duplicating the autocomplete.
export const EntitySelect = ({
  options,
  value,
  onChange,
  placeholder,
}: {
  options: EntityOption[];
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}) => {
  const selected = options.find((o) => o.value === value);
  return (
    <ProductTargetingAutofillValue
      singleSelect
      options={options}
      // Fall back to the raw id as the label while options are still loading.
      selectedValues={
        selected ? [selected] : value ? [{ label: value, value }] : []
      }
      onChange={(values) => onChange(values[0]?.value ?? "")}
      placeholder={placeholder}
    />
  );
};
